export function initRelatedProducts(query = document.querySelectorAll('.js-related-products-tabs')) {
    // Function to initialize the product tabs
    function createInstance(container) {
        const mediaQuery = window.matchMedia('(min-width: 768px)');
        let activeItemId = null; // Track the active item ID
        const listeners = new Map(); // keep references to event listeners per toggle

        function setupTabs(isDesktop) {
            const headlineWrapperDesktop = container.querySelector('[data-toggle-container]');
            const toggleElements = Array.from(container.querySelectorAll('[data-toggle-items]'));
            const items = Array.from(container.querySelectorAll('[data-item]'));

            toggleElements.forEach(toggleElement => {
                const id = toggleElement.dataset.toggleItems;
                const itemContainer = container.querySelector(`[data-item='${id}'] .container`);

                // --- clean up old listener first ---
                if (listeners.has(toggleElement)) {
                    toggleElement.removeEventListener('click', listeners.get(toggleElement));
                }

                // move DOM node
                if (isDesktop) {
                    headlineWrapperDesktop.appendChild(toggleElement);
                } else if (!itemContainer.children.length) {
                    itemContainer.appendChild(toggleElement);
                }

                // define handler
                const handler = () => {
                    if (!isDesktop && activeItemId === id) {
                        setActiveItem(null);
                    } else {
                        setActiveItem(id);
                    }
                };

                // save and attach new listener
                listeners.set(toggleElement, handler);
                toggleElement.addEventListener('click', handler);
            });

            function setActiveItem(activeId) {
                activeItemId = activeId;
                items.forEach(item =>
                    item.classList.toggle('is-active', item.dataset.item === activeId)
                );
                toggleElements.forEach(toggle =>
                    toggle.classList.toggle('is-active', toggle.dataset.toggleItems === activeId)
                );
            }

            // Restore or init
            if (activeItemId && items.some(item => item.dataset.item === activeItemId)) {
                setActiveItem(activeItemId);
            } else if (items.length) {
                setActiveItem(items[0].dataset.item);
            }
        }

        function handleMediaChange(event) {
            setupTabs(event.matches);
        }

        mediaQuery.addEventListener('change', handleMediaChange);

        // Initial setup with delay
        setTimeout(() => handleMediaChange(mediaQuery), 100);
    }

    query.forEach(createInstance);
}
